import React, { createContext } from 'react';

const DropDownContext = createContext({});

export default DropDownContext;

export const DropDownContextProvider = ({ value, children }) => {
  return <DropDownContext.Provider value={value}>{children}</DropDownContext.Provider>;
};
